export const potvrda_o_vrsti_i_trajanju_radnog_odnosa = {
    templateId: 35,
    category: 3,
    templateTitle: 'Potvrda o vrsti i trajanju radnog odnosa',
    templateDescription: `<p>Poslodavac je dužan radniku izdati potvrdu o vrsti poslova koje obavlja i trajanju radnog odnosa u roku od 15 dana od prestanka radnog odnosa (zakonske obveza) ili na zahtjev radnika tijekom trajanja radnog odnosa.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslodavac je dužan u roku od osam dana na zahtjev radnika izdati potvrdu o vrsti poslova koje obavlja i trajanju radnog odnosa.</p>
    <p>Osim toga, <strong>kod prestanka radnog odnosa</strong>, poslodavac je dužan u roku od 15 dana od prestanka radnog odnosa, osim vraćanja isprava i dostave odjava s obveznoga mirovinskog i zdravstvenog osiguranja, u istom roku i izdati potvrdu o vrsti poslova koje je obavljao i trajanju radnog odnosa.</p>
    <p>Dakle, dolje prikazanu potvrdu poslodavac izdaje radniku:</p>
    <br>
    <li> za trajanja radnog odnosa, ako radnik to zatraži,</li>
    <li> u roku od 15 dana od prestanka radnog odnosa - radi ispunjenja zakonske obveze.</li>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​izdaje sljedeću',
    title: 'POTVRDU O VRSTI POSLOVA KOJE JE OBAVLJAO RADNIK I TRAJANJU RADNOG ODNOSA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz',},
                        { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                            { type: 'text', content: ', zaposlen na radnom mjestu ' },
                            { type: 'input', value: '', required: true,  },
                            { type: 'text', content: '(u daljnjem tekstu: Radnik), bio je u radnom odnosu kod Poslodavca počevši od' },
                            {type: 'input', value: '', required: true},
                        {type: 'text', content: 'do'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine, a s kojim danom mu je prestao radni odnos.'},
                    ],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Za vrijeme rada kod Poslodavca, Radnik je obavljao poslove na radnom mjestu RADNIK, u vremenu od 1. siječnja 2010. godine do 10. svibnja 2014. godine. ',
                    value: '',
                    help: 'Ovdje unosite podatak o tome na kojim radnim mjestima je radnik radio i koliko dugo. Ukoliko je radnik radio na više radnih mjesta, za svako radno mjesto trebate navesti podatke o nazivu radnog mjesta i vremenu provedenom na tom radnom mjestu.',
                },
            ],
            value: '',
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
          static: true,
          mandatory: false,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba\r\n\r\n',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
            }
          ]
        },
        {
          static: true,
          mandatory: true,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
              content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
            },
          ]
        },
      ],
    };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/35_potvrda_o_vrsti_i_trajanju_radnog_odnosa.ts